module.exports = __webpack_public_path__ + "img/III-3.51ad39e6.svg";